const switchStyle = () => ({ readOnly: { pointerEvents: 'none' } });

export default switchStyle;
